import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";

export function initSingleProject() {
  const swipers = document.querySelectorAll(".swiper-single-project");

  swipers.forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 15,
      speed: 800,
      navigation: {
        prevEl: ".single-project-slider__btn-prev",
        nextEl: ".single-project-slider__btn-next",
      },
      pagination: {
        el: ".single-project-slider__pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 1.5, spaceBetween: 20 },
      },
    });
  });
}
